import { Component, OnInit, Output} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FireService } from '../fire.service';
import {hljs} from 'highlight.js/lib/core';
import {javascript} from 'highlight.js/lib/languages/javascript';
import 'highlight.js/styles/github.css';


@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {

  project: any
  @Output() log: boolean = false

  constructor(
    public route: ActivatedRoute,
    public fireService: FireService,
/*     public high: hljs */
  ) {}

  ngOnInit(): void {
    const url = this.route.snapshot.paramMap.get("id")
    console.log(url)
    this.matchUrl(url)
/*     this.high.registerLanguage('javascript', javascript);
    this.highlight() */
  }

  matchUrl(argument): void {
    this.fireService.getSingleId(argument).subscribe(ret => {
      this.project = ret
      console.log(ret)
    })
  }

/*   highlight(): void {
    document.querySelectorAll('pre code').forEach((block) => {
      this.high.highlightBlock(block);
    });
    console.log("please work")
  } */

  revealLog(): void {
    if(this.log){
      this.log = false
    } else {
      this.log = true
    }
    console.log(this.log)
  }

}
